// extracted by mini-css-extract-plugin
export default {"actions":"PopUpForm_actions__xAJwD"};